// Vehicle translations - English
export const vehiclesEn = {
  // Vehicles page
  page: {
    title: 'Vehicles',
    found: 'vehicles found',
    searchPlaceholder: 'Search by brand, model or year...',
    noResults: 'No vehicles found',
    noResultsDescription: 'Try adjusting the filters or search criteria',
    orderBy: 'Sort by',
    showMore: 'Show more',
  },

  // Vehicle details
  details: {
    loading: 'Loading vehicle details...',
    notFound: 'Vehicle not found',
    backToVehicles: 'Back to vehicles',
    specifications: 'Specifications',
    features: 'Features',
    contact: 'Contact about this vehicle',
    description: 'Description',
  },

  // Filters
  filters: {
    title: 'Filters',
    clearFilters: 'Clear filters',
    applyFilters: 'Apply filters',
    close: 'Close filters',
    showMore: 'Show more',
    showLess: 'Show less',
    priceRange: 'Price range',
    minPrice: 'Minimum price',
    maxPrice: 'Maximum price',
    selectBrand: 'Select a brand',
    brand: 'Brand',
    model: 'Model',
    category: 'Category',
    year: 'Year',
    fuelType: 'Fuel type',
    condition: 'Condition',
    color: 'Color',
    mileage: 'Mileage',
    dealership: 'Branch',
    facturable: 'Invoiceable',
    transmission: 'Transmission',
    transmissionManual: 'Manual',
    transmissionAutomatic: 'Automatic',
    traction: 'Drivetrain',
    traction4x2: '4x2',
    traction4x4: '4x4',
    tractionAwd: 'AWD',
    tractionFwd: 'FWD',
    facturableYes: 'With invoice',
    facturableNo: 'Without invoice',
    facturableHint:
      'Invoiceable vehicles are sold with VAT, so a company can claim the tax credit.',
  },

  // Categories
  categories: {
    all: 'All Vehicles',
    suv: 'SUV',
    sedan: 'Sedan',
    hatchback: 'Hatchback',
    pickup: 'Pickup',
    camioneta: 'Truck',
    van: 'Van',
    coupe: 'Coupe',
    wagon: 'Wagon',
    trabajo: 'Work vehicles',
  },
  categoryDescriptions: {
    all: 'Explore all our available vehicles',
    suv: 'Spacious and versatile vehicles',
    sedan: 'Comfortable family cars',
    hatchback: 'Compact and efficient',
    pickup: 'Work and cargo vehicles',
    camioneta: 'Work and double-cab trucks',
    van: 'Spacious passenger vehicles',
    coupe: 'Elegant and sporty',
    wagon: 'Versatile family vehicles',
    trabajo: 'Trucks and vehicles for job sites',
  },

  // Sorting
  sorting: {
    dateDesc: 'Newest first',
    dateAsc: 'Oldest first',
    priceAsc: 'Price: Low to High',
    priceDesc: 'Price: High to Low',
    yearDesc: 'Year: Newest',
    yearAsc: 'Year: Oldest',
    mileageAsc: 'Mileage: Low to High',
    mileageDesc: 'Mileage: High to Low',
  },

  // Vehicle card
  card: {
    year: 'Year',
    mileage: 'Mileage',
    price: 'Price',
    viewDetails: 'View details',
    contact: 'Contact',
    reserved: 'Reserved',
    sold: 'Sold',
    features: 'Features',
    fuel: 'Fuel',
    transmission: 'Transmission',
    color: 'Color',
  },

  // Status
  status: {
    available: 'Available',
    reserved: 'Reserved',
    sold: 'Sold',
    pending: 'Pending',
  },
};

